module.exports = __webpack_public_path__ + "img/pos2_banner.f91304d7.png";